import {Animatable} from "./Animatable";
import {ContainerExtensions} from "./ContainerExtensions";
import {Mix} from "./Reflection";
import {Scalable} from "./Scalable";

export class Container extends Mix(PIXI.Container, ContainerExtensions, Scalable, Animatable) {

    constructor() {
        super();
    }

    public destroy(): void {
        this.killTweens();
        super.destroy({children: true});
    }
}
